import React from 'react'
import './style.scss'
// import don from './img/dons-outils-libres-2019.jpg'

class ColibrisNavi extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: {}
    }
  }
  componentDidUpdate() {
    document.getElementsByTagName("body")[0].scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }

  componentDidMount() {
    fetch('https://colibris-lemouvement.org/archipel-markup?domain=colibris-outilslibres.org')
      .then( (response) => {
        return response.json()
      })
      .then( (json) => {
        this.setState({
          menu: json
        })
      });
  }

  render() {
      return (
        <>
          <style>{this.state.menu.style}</style>
          {/* <a href="https://cestvous.colibris-lemouvement.org/" title="Faire un don"><img className="img-bandeau-don" src={don} alt="bandeau dons" /></a> */}
          <div id="archipel-section"
            dangerouslySetInnerHTML={{ __html: this.state.menu.markup }}
          />
        </>
      );
  }
}

export default ColibrisNavi
